import { Injectable } from '@angular/core';
import {AppSettings} from '../../../settings/app-settings';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import {MSupplier} from '../model/m-supplier';

@Injectable()
export class MSupplierService {

  constructor(private http: HttpClient) { }

  public findAll(): Observable<MSupplier[]> {
    return this.http.get<MSupplier[]>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-supplier/find-all');
  }

  public save(mSupplier: MSupplier): Observable<MSupplier> {
    return this.http.post<MSupplier>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-supplier/save', mSupplier);
  }

  public delete(indexNo: number): Observable<number> {
    return this.http.delete<number>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-supplier/delete/' + indexNo);
  }

}



// WEBPACK FOOTER //
// ./src/app/view/master-files/m-supplier/service/m-supplier.service.ts